import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import transformContentHtml from "@insite/client-framework/Common/Utilities/transformContentHtml";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import parse from "html-react-parser";
import * as React from "react";
import { css } from "styled-components";

type Props = WidgetProps & HasProduct;

export interface ProductDetailsDescriptionStyles {
    wrapper?: InjectableCss;
    readButton: ButtonPresentationProps;
}

export const descriptionStyles: ProductDetailsDescriptionStyles = {
    wrapper: {
        css: css`
            margin-bottom: 15px;
            overflow: hidden;
        `,
    },
    readButton: {
        color: "primary.main",
        css: css`
            margin-bottom: 10px;
        `,
    },
};

function isLongDescription(element: HTMLElement) {
    return element.scrollHeight > 66;
}

const styles = descriptionStyles;

const ProductDetailsDescription: React.FC<Props> = ({ product }) => {
    const [hideReadMoreButton, setHideReadMoreButton] = React.useState(true);
    const [wrapperHeight, setWrapperHeight] = React.useState("65px");
    const [readMoreBool, setRead] = React.useState(false);

    React.useEffect(() => {
        const detailsContainer = document.getElementById("details-container");

        function handleLongDescription() {
            if (detailsContainer) {
                setHideReadMoreButton(!isLongDescription(detailsContainer));
            }
        }

        window.addEventListener("resize", handleLongDescription);

        handleLongDescription();
    });

    if (!product.content) {
        return null;
    }

    const readMore = () => {
        if (!readMoreBool) {
            setRead(true);
            setWrapperHeight("none");
        } else {
            setRead(false);
            setWrapperHeight("65px");
        }
    };

    return (
        <div>
            <StyledWrapper
                id="details-container"
                {...styles.wrapper}
                style={{ maxHeight: wrapperHeight, transition: "max-height 0.25s ease-in" }}
            >
                <div data-test-selector="productDetails_htmlContent">
                    {parse(transformContentHtml(product.content.htmlContent), parserOptions)}
                </div>
            </StyledWrapper>
            {!hideReadMoreButton && (
                <div>
                    {!readMoreBool && (
                        <Button onClick={readMore} variant="secondary" {...styles.readButton}>
                            Read More
                        </Button>
                    )}
                    {readMoreBool && (
                        <Button onClick={readMore} variant="secondary" {...styles.readButton}>
                            Read Less
                        </Button>
                    )}
                </div>
            )}
        </div>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsDescription),
    definition: {
        displayName: "Description",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
